export default class KVSlide {
    constructor() {
        this.runFlg = false;
        this.slides = ["kv1", "kv2", "kv3"];
        this.count = 1; //（this.slides[2]を初期表示にする）
        this.timer = [];
        this.isPlaying = false;
    }

    run() {
        if (this.runFlg) {
            return;
        }
        this.setSlide();
        this.eventBind();
        this.runFlg = true;
    }

    eventBind() {
        //読み込み時にスクロールの値を超えているかどうかもチェック
        this.onScroll(document.documentElement || document.body);

        window.addEventListener("scroll", (e) => {
            this.onScroll(document.documentElement || document.body);
        });

        //タブのアクティブ・非アクティブ時の挙動
        window.addEventListener("blur", () => {
            this.clearTimer();
        });
        window.addEventListener("focus", () => {
            if (!this.isPlaying) {
                this.setSlide("restart");
            }
        });

        //ボタンでのスライド制御
        document.querySelector(".js-mainvisual__timer__button").addEventListener("click", () => {
            this.clearTimer();
            this.setSlide();
        });
    }

    setSlide(restartFlg) {
        const $wrapper = document.body;
        const $timer = document.querySelector(".js-mainvisual__timer");
        const slides = this.slides;
        const delay = 15000;
        this.isPlaying = true;

        const loop = () => {
            slides.forEach((el) => {
                $wrapper.classList.remove(`-${el}`);
            });

            this.count++;
            if (this.count >= slides.length) {
                this.count = 0;
            }

            const tgt = slides[this.count];
            $wrapper.classList.add(`-${tgt}`);
            this.timer.push(setTimeout(loop, delay));

            //タイマースタート
            $timer.classList.add("-timer_anim");
        };

        //リスタート時は初回ディレイあり
        this.timer.push(setTimeout(loop, restartFlg ? delay : 0));

        if (restartFlg) {
            //待ち時間タイマースタート
            $timer.classList.add("-timer_anim");
        }
    }

    clearTimer() {
        const $timer = document.querySelector(".js-mainvisual__timer");

        this.timer.forEach((el) => {
            clearTimeout(el);
        });

        //CSSでのタイマーも停止
        $timer.classList.remove("-timer_anim");
        this.timer = [];
        this.isPlaying = false;
    }

    onScroll($container) {
        const scrollTop = $container.scrollTop;
        const scrollLimit = window.innerWidth < 768 ? 10 : 300;
        const $button = document.querySelector(".js-mainvisual__timer__button");

        if (scrollTop >= scrollLimit) {
            this.clearTimer();
            $button.classList.add("-disable");
        } else {
            if (!this.isPlaying) {
                this.setSlide("restart");
                $button.classList.remove("-disable");
            }
        }
    }
}
